import request from '@/utils/request'

/**
 * 获取积分商城配置分页
 * @param {*} params
 * @returns
 */
export const getClinicShopList = (params) => {
  return request({
    url: 'yia/v1/clinicShop/page',
    params
  })
}

/**
 * 新增积分商城配置
 * @param {*} data
 * @returns
 */
export const addClinicShop = (data) => {
  return request({
    method: 'POST',
    url: 'yia/v1/clinicShop/save',
    data
  })
}

/**
 * 修改积分商城配置
 * @param {*} data
 * @returns
 */
export const updateClinicShop = (data) => {
  return request({
    method: 'POST',
    url: 'yia/v1/clinicShop/update',
    data
  })
}

/**
 * 删除积分商城配置
 * @param {*} data
 * @returns
 */
export const delClinicShop = (data) => {
  return request({
    method: 'POST',
    url: 'yia/v1/clinicShop/delete',
    data
  })
}
